module.exports = __webpack_public_path__ + "static/comb-5ba62dda49644efe01dd23e220cf7a20.jpeg";